import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { alpha, createTheme } from '@mui/material/styles';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_DARK_PURPLE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_BLUE, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_DESTRUCT_STATE_1, PROMETHEAN_DESTRUCT_STATE_2, PROMETHEAN_NEUTRAL_GREY_200, PROMETHEAN_NEUTRAL_GREY_500, PROMETHEAN_NEUTRAL_GREY_600, PROMETHEAN_NEUTRAL_GREY_800, PROMETHEAN_NEUTRAL_GREY_1100, PROMETHEAN_NEUTRAL_GREY_1200, PROMETHEAN_PLUM_100 } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BUTTON, PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL } from '../styles/typography/typography';
import { PROMETHEAN_NO_SHADOW } from '../styles/elevation/elevation';
export var BUTTON_ROOT_PREFIX = 'EmbersButton';
var BLEND_PLUM_AND_DARK_PURPLE_40 = '#71379A';
var BLEND_PLUM_AND_DARK_PURPLE_60 = '#5D2985';
var BUTTON_LIGHT_GREY = '#B8B8B8';
var BUTTON_MID_GREY = '#8B8B8B';
export var BUTTON_ICON_SMALL = 16;
export var BUTTON_ICON_NORMAL = 24;
var getIconOnly = function getIconOnly(padding, minWidth) {
  return {
    paddingLeft: padding,
    paddingRight: padding,
    minWidth: minWidth,
    '.MuiButton-startIcon': {
      marginLeft: 0,
      marginRight: 0
    }
  };
};
var buttonSizes = {
  '&.MuiButton-sizeLarge': {
    height: 48,
    paddingTop: 14,
    paddingBottom: 14,
    paddingLeft: 32,
    paddingRight: 32,
    '&.EmbersButton-hasStartIcon': {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 24,
      paddingRight: 32,
      lineHeight: '24px',
      '.MuiButton-startIcon': {
        height: 24
      },
      '&.EmbersButton-icon-only': getIconOnly(24)
    },
    '&.EmbersButton-hasEndIcon': {
      lineHeight: '24px',
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 32,
      paddingRight: 56,
      '.MuiButton-endIcon': {
        top: 12,
        right: 24
      }
    },
    '&.EmbersButton-loading': {
      '&.EmbersButton-loading-center': {
        '.EmbersButton-loadingIndicator-center': {
          top: "calc(50% - ".concat(BUTTON_ICON_NORMAL / 2, "px)"),
          left: "calc(50% - ".concat(BUTTON_ICON_NORMAL / 2, "px)")
        }
      }
    }
  },
  '&.MuiButton-sizeMedium': {
    paddingTop: 10.5,
    paddingBottom: 10.5,
    paddingLeft: 24,
    paddingRight: 24,
    '&.EmbersButton-hasStartIcon': {
      lineHeight: '24px',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 16,
      paddingRight: 24,
      '.MuiButton-startIcon': {
        height: 24
      },
      '&.EmbersButton-icon-only': getIconOnly(16, 56)
    },
    '&.EmbersButton-hasEndIcon': {
      lineHeight: '24px',
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 24,
      paddingRight: 48,
      '.MuiButton-endIcon': {
        top: 8,
        right: 16
      }
    },
    '&.EmbersButton-loading': {
      '&.EmbersButton-loading-center': {
        '.EmbersButton-loadingIndicator-center': {
          top: "calc(50% - ".concat(BUTTON_ICON_NORMAL / 2, "px)"),
          left: "calc(50% - ".concat(BUTTON_ICON_NORMAL / 2, "px)")
        }
      }
    }
  },
  '&.MuiButton-sizeSmall': {
    height: 24,
    fontSize: PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL.fontSize,
    fontWeight: PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL.fontWeight,
    lineHeight: PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL.lineHeight,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 16,
    paddingRight: 16,
    '&.EmbersButton-hasStartIcon': {
      lineHeight: '16px',
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 12,
      paddingRight: 16,
      '&.EmbersButton-icon-only': getIconOnly(16, 48)
    },
    '&.EmbersButton-hasEndIcon': {
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 16,
      paddingRight: 36,
      '.MuiButton-endIcon': {
        top: 4,
        right: 12
      }
    },
    '&.EmbersButton-loading': {
      '&.EmbersButton-loading-center': {
        '.EmbersButton-loadingIndicator-center': {
          top: "calc(50% - ".concat(BUTTON_ICON_SMALL / 2, "px)"),
          left: "calc(50% - ".concat(BUTTON_ICON_SMALL / 2, "px)")
        }
      }
    }
  }
};

// For this type for buttons, when focusing, there will be an 1px transparent stroke and a 2px border,
// so to keep the button size, each padding and position value should minus 3.
var filledButtonFocusedSizes = {
  '&.MuiButton-sizeLarge': {
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 29,
    paddingRight: 29,
    '&.EmbersButton-hasStartIcon': {
      paddingTop: 9,
      paddingBottom: 9,
      paddingLeft: 21,
      paddingRight: 29,
      lineHeight: '24px',
      '.MuiButton-startIcon': {
        height: 24
      },
      '&.EmbersButton-icon-only': getIconOnly(21)
    },
    '&.EmbersButton-hasEndIcon': {
      lineHeight: '24px',
      paddingTop: 9,
      paddingBottom: 9,
      paddingLeft: 29,
      paddingRight: 53,
      '.MuiButton-endIcon': {
        top: 9,
        right: 21
      }
    }
  },
  '&.MuiButton-sizeMedium': {
    paddingTop: 7.5,
    paddingBottom: 7.5,
    paddingLeft: 21,
    paddingRight: 21,
    '&.EmbersButton-hasStartIcon': {
      lineHeight: '24px',
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 13,
      paddingRight: 21,
      '.MuiButton-startIcon': {
        height: 24
      },
      '&.EmbersButton-icon-only': getIconOnly(13, 53)
    },
    '&.EmbersButton-hasEndIcon': {
      lineHeight: '24px',
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 21,
      paddingRight: 45,
      '.MuiButton-endIcon': {
        top: 5,
        right: 13
      }
    }
  },
  '&.MuiButton-sizeSmall': {
    height: 24,
    fontSize: PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL.fontSize,
    fontWeight: PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL.fontWeight,
    lineHeight: PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL.lineHeight,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 13,
    paddingRight: 13,
    '&.EmbersButton-hasStartIcon': {
      lineHeight: '16px',
      paddingTop: 1,
      paddingBottom: 1,
      paddingLeft: 9,
      paddingRight: 13,
      '&.EmbersButton-icon-only': getIconOnly(13, 45)
    },
    '&.EmbersButton-hasEndIcon': {
      paddingTop: 1,
      paddingBottom: 1,
      paddingLeft: 13,
      paddingRight: 33,
      '.MuiButton-endIcon': {
        top: 1,
        right: 9
      }
    }
  }
};

// Add a 3px transparent border.
// And then background-clip: padding-box to make sure the original background color does not cover the border.
// Finally use `::before` to create the outer colored stroke
var getFilledButtonFocusVisibleStyle = function getFilledButtonFocusVisibleStyle(borderColor) {
  return {
    border: '3px solid transparent',
    backgroundClip: 'padding-box',
    '&::before': {
      content: '" "',
      position: 'absolute',
      top: -3,
      left: -3,
      right: -3,
      bottom: -3,
      boxShadow: "inset 0 0 0 2px ".concat(borderColor),
      borderRadius: '100px'
    }
  };
};
var getColorThemeStatus = function getColorThemeStatus(level, colorTheme, status, drawingStyle) {
  var _statusTree$level;
  var statusTree = {
    primary: {
      purple: {
        filled: {
          basic: {
            color: PROMETHEAN_NEUTRAL_WHITE,
            backgroundColor: PROMETHEAN_PURPLE_PLUM,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_WHITE
            }
          },
          hover: {
            backgroundColor: BLEND_PLUM_AND_DARK_PURPLE_40
          },
          active: {
            backgroundColor: BLEND_PLUM_AND_DARK_PURPLE_60
          },
          focus: _objectSpread(_objectSpread({
            backgroundColor: BLEND_PLUM_AND_DARK_PURPLE_40
          }, filledButtonFocusedSizes), getFilledButtonFocusVisibleStyle(PROMETHEAN_BLUE)),
          disabled: {
            backgroundColor: PROMETHEAN_NEUTRAL_DARK_GREY,
            color: PROMETHEAN_NEUTRAL_WHITE
          }
        }
      },
      white: {
        filled: {
          basic: {
            color: PROMETHEAN_PURPLE_GRAPE,
            backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
            '.icon-loading': {
              color: PROMETHEAN_PURPLE_GRAPE
            }
          },
          hover: {
            backgroundColor: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.8)
          },
          active: {
            backgroundColor: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.6),
            color: PROMETHEAN_DARK_PURPLE,
            '.icon-loading': {
              color: PROMETHEAN_DARK_PURPLE
            }
          },
          focus: _objectSpread(_objectSpread({
            backgroundColor: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.8)
          }, filledButtonFocusedSizes), getFilledButtonFocusVisibleStyle(PROMETHEAN_NEUTRAL_WHITE)),
          disabled: {
            opacity: 0.5,
            backgroundColor: BUTTON_MID_GREY,
            color: PROMETHEAN_NEUTRAL_WHITE,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_WHITE
            }
          }
        }
      },
      red: {
        filled: {
          basic: {
            color: PROMETHEAN_NEUTRAL_WHITE,
            backgroundColor: PROMETHEAN_ERROR_OR_DESTRUCT,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_WHITE
            }
          },
          hover: {
            backgroundColor: PROMETHEAN_DESTRUCT_STATE_1
          },
          focus: _objectSpread(_objectSpread({
            backgroundColor: PROMETHEAN_DESTRUCT_STATE_1
          }, filledButtonFocusedSizes), getFilledButtonFocusVisibleStyle(PROMETHEAN_BLUE)),
          active: {
            backgroundColor: PROMETHEAN_DESTRUCT_STATE_2
          },
          disabled: {
            backgroundColor: PROMETHEAN_NEUTRAL_DARK_GREY
          }
        }
      }
    },
    secondary: {
      purple: {
        outlined: {
          basic: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(BUTTON_MID_GREY),
            color: PROMETHEAN_PURPLE_GRAPE,
            backgroundColor: 'transparent',
            '.icon-loading': {
              color: PROMETHEAN_PURPLE_GRAPE
            }
          },
          hover: {
            backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.2),
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_PURPLE_GRAPE)
          },
          active: {
            backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.2),
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_DARK_PURPLE),
            color: PROMETHEAN_DARK_PURPLE,
            '.icon-loading': {
              color: PROMETHEAN_DARK_PURPLE
            }
          },
          focus: {
            boxShadow: "inset 0px 0px 0px 2px ".concat(PROMETHEAN_BLUE),
            backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.2)
          },
          disabled: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_DARK_GREY),
            backgroundColor: 'transparent',
            color: PROMETHEAN_NEUTRAL_DARK_GREY,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          }
        }
      },
      grey: {
        outlined: {
          basic: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(BUTTON_MID_GREY),
            color: PROMETHEAN_NEUTRAL_GREY_1200,
            backgroundColor: 'transparent',
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_GREY_1200
            }
          },
          hover: {
            backgroundColor: PROMETHEAN_NEUTRAL_GREY_200,
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_GREY_800)
          },
          active: {
            backgroundColor: PROMETHEAN_NEUTRAL_GREY_500,
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_GREY_1100)
          },
          focus: {
            boxShadow: "inset 0px 0px 0px 2px ".concat(PROMETHEAN_BLUE),
            backgroundColor: PROMETHEAN_NEUTRAL_GREY_200
          },
          disabled: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_DARK_GREY),
            backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
            color: PROMETHEAN_NEUTRAL_DARK_GREY,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          }
        }
      },
      white: {
        outlined: {
          basic: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(BUTTON_LIGHT_GREY),
            color: PROMETHEAN_NEUTRAL_WHITE,
            backgroundColor: 'transparent',
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_WHITE
            }
          },
          hover: {
            backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.2)
          },
          focus: {
            backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.2),
            boxShadow: "inset 0px 0px 0px 2px ".concat(PROMETHEAN_NEUTRAL_WHITE)
          },
          active: {
            backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.2)
          },
          disabled: {
            opacity: 0.5,
            backgroundColor: 'transparent',
            color: PROMETHEAN_NEUTRAL_WHITE
          }
        }
      }
    },
    tertiary: {
      purple: {
        text: {
          basic: {
            color: PROMETHEAN_PURPLE_GRAPE,
            backgroundColor: 'transparent',
            '.icon-loading': {
              color: PROMETHEAN_PURPLE_GRAPE
            }
          },
          hover: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_PURPLE_GRAPE),
            backgroundColor: alpha(PROMETHEAN_PLUM_100, 0.15)
          },
          focus: {
            backgroundColor: alpha(PROMETHEAN_PLUM_100, 0.15),
            boxShadow: "inset 0px 0px 0px 2px ".concat(PROMETHEAN_BLUE)
          },
          active: {
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_DARK_PURPLE),
            backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.4),
            color: PROMETHEAN_DARK_PURPLE,
            '.icon-loading': {
              color: PROMETHEAN_DARK_PURPLE
            }
          },
          disabled: {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            color: PROMETHEAN_NEUTRAL_DARK_GREY,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          }
        }
      },
      white: {
        text: {
          basic: {
            color: PROMETHEAN_NEUTRAL_WHITE,
            backgroundColor: 'transparent',
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_WHITE
            }
          },
          hover: {
            backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.2),
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_WHITE)
          },
          focus: {
            backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.2),
            boxShadow: "inset 0px 0px 0px 2px ".concat(PROMETHEAN_NEUTRAL_WHITE)
          },
          active: {
            backgroundColor: alpha(PROMETHEAN_PLUM_100, 0.35),
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_WHITE)
          },
          disabled: {
            boxShadow: 'none',
            opacity: 0.5,
            backgroundColor: 'transparent',
            color: PROMETHEAN_NEUTRAL_DARK_GREY,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          }
        }
      },
      grey: {
        text: {
          basic: {
            color: PROMETHEAN_NEUTRAL_GREY_1200,
            backgroundColor: 'transparent',
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_GREY_1200
            }
          },
          hover: {
            backgroundColor: BUTTON_LIGHT_GREY,
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_GREY_1100)
          },
          focus: _objectSpread(_objectSpread({
            boxShadow: 'none',
            backgroundColor: PROMETHEAN_NEUTRAL_GREY_600
          }, filledButtonFocusedSizes), getFilledButtonFocusVisibleStyle(PROMETHEAN_BLUE)),
          active: {
            backgroundColor: BUTTON_MID_GREY,
            boxShadow: "inset 0px 0px 0px 1px ".concat(PROMETHEAN_NEUTRAL_GREY_1200)
          },
          disabled: {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            color: PROMETHEAN_NEUTRAL_DARK_GREY,
            '.icon-loading': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY
            }
          }
        }
      }
    }
  };
  return ((_statusTree$level = statusTree[level]) === null || _statusTree$level === void 0 || (_statusTree$level = _statusTree$level[colorTheme]) === null || _statusTree$level === void 0 || (_statusTree$level = _statusTree$level[drawingStyle]) === null || _statusTree$level === void 0 ? void 0 : _statusTree$level[status]) || {};
};
var generateBasicStyle = function generateBasicStyle(level, colorTheme, drawingStyle) {
  return _objectSpread(_objectSpread({}, getColorThemeStatus(level, colorTheme, 'basic', drawingStyle)), {}, {
    '@media (hover: hover)': {
      '&:hover': _objectSpread({}, getColorThemeStatus(level, colorTheme, 'hover', drawingStyle))
    },
    '&.Mui-focusVisible': _objectSpread({}, getColorThemeStatus(level, colorTheme, 'focus', drawingStyle)),
    '&:active': _objectSpread({}, getColorThemeStatus(level, colorTheme, 'active', drawingStyle)),
    // the loading button should be the pressed status
    '&.EmbersButton-loading': _objectSpread({}, getColorThemeStatus(level, colorTheme, 'active', drawingStyle)),
    '&.Mui-disabled': _objectSpread({}, getColorThemeStatus(level, colorTheme, 'disabled', drawingStyle))
  });
};
export var buttonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
          display: 'inline-block'
        }, PROMETHEAN_TYPOGRAPHY_BUTTON), {}, {
          whiteSpace: 'nowrap',
          minWidth: 'fit-content',
          textTransform: 'none',
          boxSizing: 'border-box',
          outline: 'none',
          borderRadius: '100px',
          border: 'none'
        }, PROMETHEAN_NO_SHADOW), {}, {
          '@media (hover: hover)': {
            '&:hover': _objectSpread({
              border: 'none'
            }, PROMETHEAN_NO_SHADOW)
          },
          '&.Mui-focusVisible': {
            boxShadow: 'none',
            transition: 'background-color linear 0.2s'
          },
          '&:active': _objectSpread({}, PROMETHEAN_NO_SHADOW),
          '&.Mui-disabled': {
            border: 'none',
            cursor: 'not-allowed',
            pointerEvents: 'all'
          },
          // loading
          '&.EmbersButton-loading': {
            cursor: 'default',
            '&.EmbersButton-loading-center': {
              '>span': {
                visibility: 'hidden'
              },
              '.EmbersButton-loadingIndicator-center': {
                visibility: 'visible',
                position: 'absolute',
                display: 'flex',
                top: "calc(50% - ".concat(BUTTON_ICON_NORMAL / 2, "px)"),
                left: "calc(50% - ".concat(BUTTON_ICON_NORMAL / 2, "px)")
              }
            }
          }
        }, buttonSizes), {}, {
          // levels then colors then drawing styles
          '&.EmbersButton-primaryLevel': {
            '&.EmbersButton-purpleColor': {
              '&.EmbersButton-filledDrawingStyle': _objectSpread({}, generateBasicStyle('primary', 'purple', 'filled'))
            },
            '&.EmbersButton-whiteColor': {
              '&.EmbersButton-filledDrawingStyle': _objectSpread({}, generateBasicStyle('primary', 'white', 'filled'))
            },
            '&.EmbersButton-redColor': {
              '&.EmbersButton-filledDrawingStyle': _objectSpread({}, generateBasicStyle('primary', 'red', 'filled'))
            }
          },
          '&.EmbersButton-secondaryLevel': {
            '&.EmbersButton-purpleColor': {
              '&.EmbersButton-outlinedDrawingStyle': _objectSpread({}, generateBasicStyle('secondary', 'purple', 'outlined'))
            },
            '&.EmbersButton-greyColor': {
              '&.EmbersButton-outlinedDrawingStyle': _objectSpread({}, generateBasicStyle('secondary', 'grey', 'outlined'))
            },
            '&.EmbersButton-whiteColor': {
              '&.EmbersButton-outlinedDrawingStyle': _objectSpread({}, generateBasicStyle('secondary', 'white', 'outlined'))
            }
          },
          '&.EmbersButton-tertiaryLevel': {
            '&.EmbersButton-purpleColor': {
              '&.EmbersButton-textDrawingStyle': _objectSpread({}, generateBasicStyle('tertiary', 'purple', 'text'))
            },
            '&.EmbersButton-whiteColor': {
              '&.EmbersButton-textDrawingStyle': _objectSpread({}, generateBasicStyle('tertiary', 'white', 'text'))
            },
            '&.EmbersButton-greyColor': {
              '&.EmbersButton-textDrawingStyle': _objectSpread({}, generateBasicStyle('tertiary', 'grey', 'text'))
            }
          }
        }),
        iconSizeLarge: {
          '&.MuiButton-startIcon': {
            marginLeft: -3
          },
          '[class^="icon-"]': {
            fontSize: BUTTON_ICON_NORMAL
          }
        },
        iconSizeMedium: {
          '&.MuiButton-startIcon': {
            marginLeft: -3
          },
          '[class^="icon-"]': {
            fontSize: BUTTON_ICON_NORMAL
          }
        },
        iconSizeSmall: {
          '[class^="icon-"]': {
            fontSize: BUTTON_ICON_SMALL
          }
        },
        startIcon: {
          display: 'inline-block',
          verticalAlign: 'top'
        },
        endIcon: {
          display: 'block',
          position: 'absolute',
          '[class^="icon-"]': {
            fontSize: 16
          }
        }
      }
    }
  }
});